<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Withdrawal Logs'
                    : 'Deleted Withdrawal Logs'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search Transfer ID, Status, Mode..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="status"
                    v-model="filter.status"
                    :items="statusOptions"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="active_status"
                    v-model="filter.is_active"
                    :items="activeStatuses"
                    label="Active Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-power"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="loading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Transfer ID</th>
                      <th class="text-left">User</th>
                      <th class="text-left">Bank Details</th>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Mode</th>
                      <th class="text-left">Active</th>
                      <th class="text-left">Created Date</th>
                    </tr>
                  </thead>
                  <tbody v-if="withdrawal_logs.length != 0">
                    <tr
                      v-for="(item, i) in withdrawal_logs"
                      :key="`withdrawal${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>
                        <v-chip
                          :color="item.status_badge_color"
                          text-color="white"
                          small
                        >
                          {{ item.status_text || "N/A" }}
                        </v-chip>
                      </td>
                      <td>{{ item.transfer_id || "" }}</td>
                      <td>
                        <div v-if="item.user">
                          {{ item.user.first_name }} {{ item.user.last_name }}
                          <br />
                          <small class="text--secondary">{{
                            item.user.phone
                          }}</small>
                        </div>
                        <span v-else class="text--disabled">N/A</span>
                      </td>
                      <td>
                        <div v-if="item.bank_detail">
                          {{ item.bank_detail.name }}
                          <br />
                          <small class="text--secondary">{{
                            item.bank_detail.account_number
                          }}</small>
                        </div>
                        <span v-else class="text--disabled">N/A</span>
                      </td>
                      <td>
                        <v-chip
                          :color="getAmountColor(item.transfer_amount)"
                          text-color="white"
                          small
                        >
                          ₹{{ item.transfer_amount }}
                        </v-chip>
                      </td>
                      <td>{{ item.transfer_mode || "" }}</td>
                      <td>
                        <v-tooltip bottom v-if="item.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Withdrawal log is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Withdrawal log is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ formatDate(item.created_at) }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination
                v-model="page"
                :length="paginationLength"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_withdrawal_log" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Withdrawal log deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_withdrawal_log = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_withdrawal_log" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Withdrawal log restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_withdrawal_log = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Statistics Dialog -->
    <v-dialog v-model="statisticsDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>Withdrawal Statistics</h3>
        </v-card-title>
        <v-card-text>
          <v-row v-if="statistics">
            <v-col cols="6">
              <v-card color="primary" dark>
                <v-card-text>
                  <div class="text-h4">{{ statistics.total_withdrawals }}</div>
                  <div>Total Withdrawals</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card color="success" dark>
                <v-card-text>
                  <div class="text-h4">
                    {{ statistics.successful_withdrawals }}
                  </div>
                  <div>Successful</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card color="warning" dark>
                <v-card-text>
                  <div class="text-h4">
                    {{ statistics.pending_withdrawals }}
                  </div>
                  <div>Pending</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card color="error" dark>
                <v-card-text>
                  <div class="text-h4">{{ statistics.failed_withdrawals }}</div>
                  <div>Failed</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card color="info" dark>
                <v-card-text>
                  <div class="text-h4">
                    ₹{{ formatAmount(statistics.successful_amount) }}
                  </div>
                  <div>Total Successful Amount</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="statisticsDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "withdrawalLogsPage",
  data() {
    return {
      loading: false,
      withdrawal_logs: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_withdrawal_log: false,
      is_restored_withdrawal_log: false,
      statisticsDialog: false,
      statistics: null,
      filter: {
        search_keyword: "",
        status: "",
        is_active: "",
        show_deleted: false,
      },
      statusOptions: [
        {
          id: 0,
          text: "Select Status",
          value: "",
        },
        { id: "PENDING", text: "Pending", value: "PENDING" },
        { id: "SUCCESS", text: "Success", value: "SUCCESS" },
        { id: "FAILED", text: "Failed", value: "FAILED" },
        { id: "CANCELLED", text: "Cancelled", value: "CANCELLED" },
        { id: "PROCESSING", text: "Processing", value: "PROCESSING" },
      ],
      activeStatuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      errors: "errors/errors",
    }),
    rowsPerPage() {
      return 10;
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.show_deleted ? 1 : 0;
      this.loading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&search_keyword=" +
        this.filter.search_keyword;

      await axios
        .get(`withdrawal_logs?${query}`)
        .then((response) => {
          this.withdrawal_logs = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.loading = false;
    },

    async softDelete(item) {
      await axios
        .post(`/withdrawal_logs/delete/${item.id}`)
        .then(() => {
          this.is_deleted_withdrawal_log = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async restoreRecord(item) {
      await axios
        .post(`/withdrawal_logs/restore/${item.id}`)
        .then(() => {
          this.is_restored_withdrawal_log = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async exportToExcel() {
      try {
        const params = { ...this.filter };
        const response = await axios.get("/withdrawal_logs/excel", {
          params,
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `withdrawal_logs_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel export successful");
      } catch (error) {
        console.error("Error exporting to excel:", error);
        this.$store.dispatch("errors/setError", error);
      }
    },

    async getStatistics() {
      try {
        const response = await axios.get("/withdrawal_logs/statistics");
        this.statistics = response.data.data;
        this.statisticsDialog = true;
      } catch (error) {
        console.error("Error fetching statistics:", error);
        this.$store.dispatch("errors/setError", error);
      }
    },

    isDeletePage() {
      let response = false;
      if (this.$route.query.show_deleted) {
        response = true;
      }
      return response;
    },

    toggleDeletePage() {
      if (this.isDeletePage()) {
        this.$router.push("/withdrawal_logs");
      } else {
        this.$router.push("/withdrawal_logs?show_deleted=true");
      }
    },

    canCreate() {
      return ["admin", "super_admin"].includes(this.user?.role);
    },

    canDelete() {
      return ["admin", "super_admin"].includes(this.user?.role);
    },

    getAmountColor(amount) {
      if (amount >= 5000000) return "red"; // 50,000+ rupees
      if (amount >= 1000000) return "orange"; // 10,000+ rupees
      return "green";
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    },

    formatAmount(amount) {
      if (!amount) return "0.00";
      return (amount / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>